import {
  EcommerceProductDimensionMeasurementEnum,
  EcommerceProductUnitOfMeasurementEnum,
  InvoiceStatusEnum,
  JobBoardsVacanciesApplicationStatusEnum,
  SaleOrderStatusEnum,
  StockLocationStatusEnum,
  VendorTypeEnum,
} from 'generated/api'

import { mapStatusOrder } from 'helpers/wording'
import { categoryJobVacanciesEnum } from 'pages/job-vacancy/hooks/jobVacancyEnum'

export const DropdownInvoiceStatus = [
  {
    value: '',
    label: 'Semua Status',
    key: 0,
  },
  {
    value: InvoiceStatusEnum.Paid,
    label: 'Sudah Dibayar',
    key: 1,
  },
  {
    value: InvoiceStatusEnum.PartialPaid,
    label: 'Dibayar Sebagian',
    key: 2,
  },
  {
    value: InvoiceStatusEnum.Unpaid,
    label: 'Belum Dibayar',
    key: 3,
  },
  {
    value: InvoiceStatusEnum.Expired,
    label: 'Kedaluwarsa',
    key: 4,
  },
  {
    value: InvoiceStatusEnum.Cancelled,
    label: 'Dibatalkan',
    key: 5,
  },
  {
    value: InvoiceStatusEnum.Void,
    label: 'Void',
    key: 6,
  },
]
export const DropdownPageLimit = [
  {
    value: 10,
    key: '0',
  },
  {
    value: 20,
    key: '1',
  },
  {
    value: 50,
    key: '2',
  },
]

export const DropDownEcommerceProductUnitOfMeasurement = [
  { label: 'Gram', value: EcommerceProductUnitOfMeasurementEnum.Gram },
  { label: 'Kg', value: EcommerceProductUnitOfMeasurementEnum.Kg },
  { label: 'Pcs', value: EcommerceProductUnitOfMeasurementEnum.Pcs },
  { label: 'Sak', value: EcommerceProductUnitOfMeasurementEnum.Sak },
  { label: 'Ton', value: EcommerceProductUnitOfMeasurementEnum.Ton },
  { label: 'Liter', value: EcommerceProductUnitOfMeasurementEnum.Liter },
  { label: 'Pack', value: EcommerceProductUnitOfMeasurementEnum.Pack },
]

export const DropDownEcommerceProductDimensionMeasurement = [
  { label: 'mm', value: EcommerceProductDimensionMeasurementEnum.Mm },
  { label: 'cm', value: EcommerceProductDimensionMeasurementEnum.Cm },
  { label: 'm', value: EcommerceProductDimensionMeasurementEnum.M },
]

export enum DropDownEcommerceProductStatusEnum {
  ALL = 'ALL',
  ACTIVE = 'ACTIVE',
  INACTIVE = 'INACTIVE',
}

export const DropDownEcommerceProductStatus = [
  { label: 'Semua Status', value: DropDownEcommerceProductStatusEnum.ALL },
  { label: 'Aktif', value: DropDownEcommerceProductStatusEnum.ACTIVE },
  { label: 'Tidak Aktif', value: DropDownEcommerceProductStatusEnum.INACTIVE },
]

export const DropDownStockLocationStatus = [
  { label: 'Semua Status', value: '' },
  { label: 'Aktif', value: StockLocationStatusEnum.Active },
  { label: 'Tidak Aktif', value: StockLocationStatusEnum.Inactive },
]

export const DropDownVendorType = [
  { label: 'Semua Tipe', value: '' },
  { label: 'Toko Tani', value: VendorTypeEnum.FarmerStore },
  { label: 'Toko Sembako', value: VendorTypeEnum.GroceryStore },
  { label: 'Perusahaan', value: VendorTypeEnum.Company },
]

export const DropDownVendorStatus = [
  { label: 'Semua Status', value: '' },
  { label: 'Aktif', value: StockLocationStatusEnum.Active },
  { label: 'Tidak Aktif', value: StockLocationStatusEnum.Inactive },
]

export const DropDownSaleOrderStatus = [
  { value: '', label: 'Semua Status' },
  {
    value: SaleOrderStatusEnum.Draft,
    label: mapStatusOrder(SaleOrderStatusEnum.Draft),
  },
  { value: SaleOrderStatusEnum.New, label: mapStatusOrder(SaleOrderStatusEnum.New) },
  {
    value: SaleOrderStatusEnum.Confirmed,
    label: mapStatusOrder(SaleOrderStatusEnum.Confirmed),
  },
  {
    value: SaleOrderStatusEnum.ReadyToPickUp,
    label: mapStatusOrder(SaleOrderStatusEnum.ReadyToPickUp),
  },
  {
    value: SaleOrderStatusEnum.Delivering,
    label: mapStatusOrder(SaleOrderStatusEnum.Delivering),
  },
  {
    value: SaleOrderStatusEnum.Completed,
    label: mapStatusOrder(SaleOrderStatusEnum.Completed),
  },
  {
    value: SaleOrderStatusEnum.Cancelled,
    label: mapStatusOrder(SaleOrderStatusEnum.Cancelled),
  },
  {
    value: SaleOrderStatusEnum.CancelApproval,
    label: mapStatusOrder(SaleOrderStatusEnum.CancelApproval),
  },
]

export const DropDownCategoryJobVacancy = [
  {
    label: 'Semua Kategori',
    value: categoryJobVacanciesEnum.DEFAULT,
  },
  {
    label: 'Pemanen',
    value: categoryJobVacanciesEnum.HARVESTER,
  },
  {
    label: 'Penjaga Kebun',
    value: categoryJobVacanciesEnum.UPKEEPER,
  },
]

export const DropDownStatusJobApplicant = [
  {
    label: 'Semua Status',
    value: '',
  },
  {
    label: 'Diterima',
    value: JobBoardsVacanciesApplicationStatusEnum.Accepted,
  },
  {
    label: 'Menunggu',
    value: JobBoardsVacanciesApplicationStatusEnum.Pending,
  },
  {
    label: 'Ditolak',
    value: JobBoardsVacanciesApplicationStatusEnum.Rejected,
  },
]
